export default "__VITE_ASSET__D45TAbw6__"